import styled from "styled-components"

const StyledMainContent = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  width: 100%;
  @media only screen and (max-width: 640px) {
    width: 75%;
    max-width: 920px;
    margin: 0 auto;
    align-items: center;
  }
`

export default StyledMainContent
